import * as React from 'react';
import { Icon } from '@salesforce/design-system-react';

type Props = {
	className: string
	entity: string
	placeholder: string
};

const FakeLookup: React.SFC<Props> = ({className , entity, placeholder}) => (
	<div className={`slds-form-element__control ${className}`}>
		<div className="slds-combobox-group">
			<div className="slds-combobox_object-switcher slds-combobox-addon_start">
				<div className="slds-form-element">
					<label className="slds-form-element__label slds-assistive-text">Filter Search by:</label>
					<div className="slds-form-element__control">
						<div className="slds-combobox_container">
							<div className="slds-combobox slds-dropdown-trigger slds-dropdown-trigger_click" >
								<div className="slds-combobox__form-element slds-input-has-icon slds-input-has-icon_right" role="none">
									<input 
										type="text"
										className="slds-input slds-combobox__input slds-combobox__input-value"
										auto-complete="off"
										placeholder=" "
										value={entity}
									/>
									<Icon 
										category="utility"
										name="down"
										size="xx-small"
										containerClassName="slds-input__icon slds-input__icon_right"
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="slds-combobox_container slds-combobox-addon_end">
				<div className="slds-combobox slds-dropdown-trigger slds-dropdown-trigger_click">
					<div className="slds-combobox__form-element slds-input-has-icon slds-input-has-icon_right" role="none">
						<input
							type="text"
							className="slds-input slds-combobox__input"
							auto-complete="off"
							placeholder={placeholder}
						/>
						<Icon 
							category="utility"
							name="search"
							size="x-small"
							containerClassName="slds-input__icon slds-input__icon_right"
						/>
					</div>
				</div>
			</div>
		</div>
	</div>
);

export default FakeLookup;



// WEBPACK FOOTER //
// ./src/lib/FakeLookup.tsx